export enum DownloadApplicationCsvTypes {
  FETCH_DOWNLOAD_APPLICATIONCSV_SUCCESS = "FETCH_DOWNLOAD_APPLICATIONCSV_SUCCESS",
  FETCH_DOWNLOAD_APPLICATIONCSV_FAILURE = "FETCH_DOWNLOAD_APPLICATIONCSV_FAILURE",
  FETCH_DOWNLOAD_APPLICATIONCSV_REQUEST = "FETCH_DOWNLOAD_APPLICATIONCSV_REQUEST"
}